/**
 * Preço por pessoa e total aproximado do plano, compartilhado pelo Step 2 e
 * pela revisão. Pessoa sem preço aparece como "a confirmar com a operadora" e
 * nunca bloqueia a escolha do plano.
 */

import { formatCents, summarizeMonthly } from "../pricing";
import { Caption, Row, Stack } from "../styled";
import { IDependent, IEligiblePlan, IHolder } from "../types";

export const TO_CONFIRM = "a confirmar com a operadora";

/** Texto do total: soma dos conhecidos, ou o aviso quando ninguém tem preço. */
export function formatTotalText(
  plan: IEligiblePlan,
  retainedDependentTaxPayerIds: string[]
): string {
  const { knownCents, unknownCount, people } = summarizeMonthly(
    plan,
    retainedDependentTaxPayerIds
  );

  if (unknownCount === people.length) return "Valor a confirmar com a operadora";

  const total = `${formatCents(knownCents)}/mês`;

  return unknownCount > 0 ? `${total} sem os valores a confirmar` : total;
}

interface IProps {
  plan: IEligiblePlan;
  holder: IHolder;
  dependents: IDependent[];
  retainedDependentTaxPayerIds: string[];
}

export function PriceBreakdown({
  plan,
  holder,
  dependents,
  retainedDependentTaxPayerIds,
}: IProps) {
  const { people } = summarizeMonthly(plan, retainedDependentTaxPayerIds);

  return (
    <Stack $gap="8px">
      <Caption>Valor integral mensal por pessoa</Caption>
      <Caption>
        o valor cobrado pela operadora, sem descontar a parte da empresa
      </Caption>

      {people.map((person) => {
        const index = plan.prices.indexOf(person);
        const name = index === 0 ? holder.name : dependents[index - 1]?.name;

        return (
          <Row key={`${index}-${person.taxPayerId}`} $justify="space-between">
            <Caption>
              {name} ·{" "}
              {person.age === null
                ? "idade não informada"
                : `${person.age} ${person.age === 1 ? "ano" : "anos"}`}
              {person.band ? ` · faixa ${person.band}` : ""}
            </Caption>
            <Caption>
              {person.cents === null ? TO_CONFIRM : formatCents(person.cents)}
            </Caption>
          </Row>
        );
      })}
    </Stack>
  );
}
